// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3n37L","image":"Header_image__345Z0","name":"Header_name__1fUv-","info":"Header_info__1x-OV","infoRow":"Header_infoRow__3Qy9F"};